import QueueableRequest from './QueueableRequest';
import * as endpoints from '../../config/api';

export default class DownloadsRequest extends QueueableRequest {
  constructor() {
    super(endpoints.DOWNLOADS_ENDPOINT);
  }
}
